import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { ReactNode } from 'react';

/**
 * Committed rank insignia, never composited at runtime — `/images/ranks/<key>.png`.
 * Decorative by default (alt=""); pass `label` where the emblem is the ONLY
 * indicator of the level (e.g. a leaderboard row with no adjacent rank text) so
 * screen-reader users still get the level.
 */
export function RankEmblem(t0) {
  const $ = _c(6);
  const {
    rankKey,
    size: t1,
    className,
    label
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  if (!rankKey) {
    return null;
  }
  const t2 = `/images/ranks/${rankKey}.png`;
  const t3 = label ?? "";
  const t4 = label ? undefined : true;
  let t5;
  if ($[0] !== className || $[1] !== size || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <Image src={t2} alt={t3} width={size} height={size} className={className} aria-hidden={t4} />;
    $[0] = className;
    $[1] = size;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}